import { ReactComponent as TreeViewSVG } from "./svg/tree.svg";
import { ReactComponent as TreeViewDarkSVG } from "./svg/tree_dark.svg";
import { ReactComponent as TreeViewDisabledSVG } from "./svg/tree_disabled.svg";
import "./IconTreeView.scss";

type IconTreeViewProps = {
  variant?: "active" | "inactive" | "disabled";
};

export const IconTreeView = ({ variant = "active" }: IconTreeViewProps) => {
  return (
    <span className="icon-tree-view">
      {variant === "active" && <TreeViewSVG />}
      {variant === "inactive" && <TreeViewDarkSVG />}
      {variant === "disabled" && <TreeViewDisabledSVG />}
    </span>
  );
};
